module.exports = __webpack_public_path__ + "static/media/group54@2x.95125a76.png";